<template>
    <div class=" index">
        <div class="main-header">
            <div class="bg"></div>

            <div class="main-btn f-h flex">
                <div class="rr f-grow flex f-h btn" @click="emit('jump')">
                    <div class="flex f-v f-v-center" style="align-items: flex-start;">
                        <div class="flex f-h f-v-center">
                            <span class="b">约课</span>
                            <span class="s">class</span>
                        </div>
                        <div class="t1" >Schedule</div>
                        <div class="b2">点击约课</div>
                    </div>
                    <img :src="require('@/assets/icons/b1.png')" >
                </div>
                <div style="width: 10px"></div>
<!--                2025-10-15 因域名被封尝试注释 -->
<!--                <div class="rr f-grow flex f-h btn" @click="router.push('/buy')">
                    <div class="flex f-v f-v-center" style="align-items: flex-start;">
                        <div class="flex f-h f-v-center">
                            <span class="b">购课</span>
                            <span class="s">&nbsp;hot&nbsp;</span>
                        </div>
                        <div class="t1" >Shopping</div>
                        <div class="b2">点击购课</div>
                    </div>
                    <img :src="require('@/assets/icons/b3.png')" >
                </div>-->
                <!--<div class="flex f-v f-grow">
                    <div class="rr  flex f-h btn" @click="router.push('/buy')">
                        <div class="flex f-v f-h-center f-v-center">
                            <div class="flex f-h f-v-center">
                                <span class="b">购课</span>
                                <span class="s">hot</span>
                            </div>
                            <div class="t1">shopping mall</div>
                        </div>
                        <img :src="require('@/assets/icons/b2.png')" >
                    </div>
                    <div class="health txt-right">___health</div>
                </div>-->

            </div>
        </div>

        <div class="notice-list flex f-v">
            <div class="nt flex f-h f-sb">
                <div class="txt">公告通知</div>
                <div class="more" @click="router.push('/noticeList')">查看更多></div>
            </div>
            <div class="list">
                <div class="notice-item flex f-v"
                     v-for="(item, i) in data.noticeList"
                     :key="i">
                    <div class="title flex f-sb f-h-center">
                        <div class="l">{{item.name}}</div>
                        <div class="date">{{t.formatDate(item.create_time, 'yyyy/MM/dd')}}</div>
                    </div>
                    <div class="content txt-ellipsis txt-left">
                        {{item.content}}
                    </div>
                </div>
                <div v-if="data.loading"
                     class="loading-warp flex f-v-center f-center">
                    <loading/>
                    <span> 加载中...</span>
                </div>
            </div>
        </div>

        <div class="info" v-for="(v, i) in data.venueList" :key="i">
            <img :src="v.img_url || require('@/assets/icons/info.png')"/>
            <div class="txt txt-left">
                <div class="title">{{v.name}}</div>

                <div class="t1">
                    <span class="l">营业时间</span>
                    <span >{{v.time}}</span>
                </div>
                <div class="t1">
                    <span class="l">电话</span>
                    <span >{{v.phone}}</span>
                </div>
                <div class="t1">
                    <span class="l" style="vertical-align: top;">地址</span>
                    <span >{{v.address}}</span>
                    <!--<a href="javascript:void(0)" @click="nav()">&nbsp;导航</a>-->
                </div>
            </div>
        </div>

        <div class="txt-center p20" style="font-size: .24rem; color: #8E8E8E;">沪ICP备2025117468号-2</div>
    </div>
</template>

<script setup>
    import Loading from '@/components/LLoading.vue';
    import router from '../router/index.js';
    import waitInit from '@/lib/init.js';
    import api from '@/api/api.js';
    import t from '@zh-or/lib';
    import u from '@/lib/tools.js';
    import {ref, reactive} from 'vue';
    let emit = defineEmits(['jump']);
    let data = reactive({
        loading: true,
        noticeList: [],
        venueList: []
    })

    waitInit(() => {
        data.loading = true;
        Promise.all([
            api.getNoticeList({limit: 5}),
            api.getMainInfo()
        ])
            .then(([notice, info]) => {
                if(notice.code == 1) {
                    data.noticeList = notice.data;
                }

                if(info.code == 1) {
                    data.venueList = info.data || [];
                }
                data.loading = false;
            })
            .catch(e => {
                console.error('初始化出错:', e);
            })
    });

    function nav() {
        //29.548708,106.522381
        wx.openLocation({
            latitude: 29.548708, // 纬度，浮点数，范围为90 ~ -90
            longitude: 106.522381, // 经度，浮点数，范围为180 ~ -180。
            name: data.venueList[0] ? data.venueList[0].name : '', // 位置名
            address: data.venueList[0] ? data.venueList[0].address : '', // 地址详情说明
            scale: 28, // 地图缩放级别,整型值,范围从1~28。默认为最大
            infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        });
    }
</script>

<style lang="scss">
.index {
    .main-header {

        .bg {
            height: 100px;
            background: linear-gradient(180deg, #40D9C7 0%, #ACEAE2 60%, rgba(245, 245, 245, 0) 100%);
        }

        .main-btn {
            padding: $page-lr-pd;
            margin-top: -60px;

            .rr {
                color: #606060;
                background-color: #fff;
                border-radius: 10px 10px 10px 10px;
                padding: 12px;
                justify-content: space-between;
                box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);

                img {
                    width: 1.1rem;
                    height: 1.1rem;
                }

                .b {
                    font-size: .44rem;
                    font-weight: bold;
                }

                .s {
                    background: #FFC547;
                    border-radius: 2px 2px 2px 2px;
                    color: #fff;
                    font-size: .2rem;
                    margin-left: 10px;
                    padding: 2px 5px;
                }

                .t1 {
                    margin: 8px 0;
                }

                .b2 {
                    background: #40D9C7;
                    border-radius: 20px 20px 20px 20px;
                    padding: 2px 10px;
                    color: #fff;
                }
            }

            .health {
                background: linear-gradient( 119deg, #40D9C7 0%, #65FBE9 100%);
                box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);
                border-radius: 10px 10px 10px 10px;
                color: #fff;
                padding: 3px 10px;
                margin-top: 8px;
            }
        }

    }


    .info {
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);
        border-radius: 10px 10px 10px 10px;
        margin: $page-lr-pd;
        display: flex;
        gap: 12px;
        padding: 16px;
        align-items: center;

        img {
            width: 40%;
            max-width: 150px;
            height: auto;
            border-radius: 8px;
            object-fit: cover;
            flex-shrink: 0;

            display: block;
        }

        .txt {
            flex: 1;
            
            

            .title {
                font-size: .30rem;
                color: #606060;
                margin-bottom :15px;
            }

            .t1 {
                color: #8E8E8E;
                font-size: .24rem;
                border-bottom: 1px solid rgba(227,227,227,0.6);
                padding: 5px 0;

                .l {
                    display: inline-block;
                    min-width: 5em;
                }

                .l + span {
                    max-width: 13em;
                }
            }
        }
    }
}
</style>
